module.exports = __webpack_public_path__ + "static/7-6f3fb49232faf4618c67fa021b70f3dd.jpg";